/** Browser-runtime latch for an explicitly confirmed financial transport.
 * No persistence, retries, provider calls, or navigation live in this module.
 */
export type FinancialTransportToken = symbol;

let activeToken: FinancialTransportToken | null = null;
const listeners = new Set<() => void>();

export function hasPendingFinancialTransport(): boolean {
  return activeToken !== null;
}

export function subscribeFinancialTransport(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Acquire synchronously, before scheduling the mutation or starting fetch. */
export function beginFinancialTransport(): FinancialTransportToken | null {
  if (activeToken !== null) return null;
  const token = Symbol("financial-transport");
  activeToken = token;
  listeners.forEach((listener) => listener());
  return token;
}

/** A stale callback must never release a newer attempt's guard. */
export function endFinancialTransport(token: FinancialTransportToken): void {
  if (activeToken !== token) return;
  activeToken = null;
  listeners.forEach((listener) => listener());
}
